export const ENV_LOCAL = 'local'
export const ENV_TEST = 'test'
export const ENV_STAGE = 'stage'
export const ENV_LIVE = 'live'

export const TIMEZONE = '+0100'

export const STATUS_CODE_NO_SESSION = 401
export const STATUS_CODE_MAINTENANCE = 503

export const CART_ID_COOKIE_NAME = 'cart_id'
